<template>
  <van-steps class="process-steps" :active="activeIndex" direction="vertical">
    <van-step v-for="(caseRecord,i) in caseRecords" :key="i">
      <div
        :slot="i===activeIndex?'active-icon':'inactive-icon'"
        :class="['step-label',
                 'step-label--'+getProcessStatus(caseRecord),
                 {'step-label--active':i===activeIndex}]"
      >
        <span class="step-label__title">{{ caseRecord.flowNodeName }}</span>
        <van-loading
          v-if="getProcessStatus(caseRecord)==='process'"
          class="step-label__icon"
          color="#07c160"
          size="20px"
        />
        <van-icon
          v-else-if="getProcessStatus(caseRecord)==='finish'"
          class="step-label__icon"
          :name="i===activeIndex?'success-fill':'up-circle'"
          size="20px"
          class-prefix="iconfont"
        />
        <van-icon v-else class="step-label__icon" name="clock" size="20px" class-prefix="iconfont" />
      </div>
      <process-steps v-if="caseRecord.children" :case-records="caseRecord.children" />
      <div
        v-else
        :class="['step-content',
                 'step-content--'+getProcessStatus(caseRecord),
                 {'step-content--active':i===activeIndex}]"
      >
        <div class="step-content__title">
          <van-icon slot="icon" name="person" class-prefix="iconfont" />
          {{ caseRecord.transactorName||'系统' }}
        </div>
        <div v-if="caseRecord.reason" class="step-content__reason">
          <van-icon slot="icon" name="suggest" class-prefix="iconfont" />
          {{ caseRecord.reason }}
        </div>
        <div class="step-content__time">
          <van-icon slot="icon" name="clock" class-prefix="iconfont" />
          {{ (caseRecord.endTime||caseRecord.startTime)|dateTime }}
        </div>
      </div>
    </van-step>
  </van-steps>
</template>

<script>
import { formatDate } from '@/utils'
import { ProcessStatus } from '@/utils/enums'

export default {
  name: 'ProcessSteps',
  filters: {
    dateTime: function(dateString) {
      return formatDate(new Date(dateString), 'yyyy-MM-dd hh:mm:ss')
    }
  },
  props: {
    caseRecords: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: 0
    }
  },
  computed: {
    activeCaseRecord() {
      return this.caseRecords[this.activeIndex]
    }
  },
  methods: {
    getProcessStatus(caseRecord) {
      let processStatus
      if (caseRecord === this.activeCaseRecord) {
        if (caseRecord.endTime || caseRecord.transactionType != null) {
          // 已办
          processStatus = ProcessStatus.Finish
        } else {
          // 在办
          processStatus = ProcessStatus.Process
        }
      } else if (caseRecord.startTime < this.activeCaseRecord.startTime) {
        // 已办
        processStatus = ProcessStatus.Finish
      } else {
        // 未办
        processStatus = ProcessStatus.Normal
      }
      return processStatus.key.toLowerCase()
    }
  }
}
</script>

<style lang="scss">
.process-steps {
  .van-step--finish .van-step__line {
    background-color: #ebedf0;
  }
}
</style>

<style scoped lang="scss">
.process-steps {
  padding-left: 90px;
  .van-step {
    .step-label {
      margin-left: -60px;
      width: 82px;
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      .step-label__title {
        display: block;
        float: left;
        width: 60px;
        text-align: right;
        font-weight: 700;
      }
      .step-label__icon {
        float: right;
        background-color: white;
      }
    }
    .step-label--normal {
      color: #333333;
    }
    .step-label--finish {
      color: #969799;
    }
    .step-label--active,
    .step-label--process {
      color: #07c160;
    }
    .step-content {
      line-height: 20px;
      .step-content__title {
        font-size: 14px;
      }
      .step-content__reason {
        font-size: 12px;
      }
      .step-content__time {
        font-size: 12px;
      }
    }
    .step-content--normal {
      color: #333333;
    }
    .step-content--finish {
      color: #969799;
    }
    .step-content--active,
    .step-content--process {
      color: #07c160;
    }
  }
}
</style>
